
import { DefaultState } from 'store/types';

export const ROOM_REPORT_EXCEL_REQUEST = 'ROOM_REPORT_EXCEL_REQUEST';
export const ROOM_REPORT_EXCEL_SUCCESS = 'ROOM_REPORT_EXCEL_SUCCESS';
export const ROOM_REPORT_EXCEL_FAILURE = 'ROOM_REPORT_EXCEL_FAILURE';

export interface RoomReportExcelParams {
  reportId: string;
};

export type RoomReportExcelState = DefaultState & {
  contents?: {};
};

interface RoomReportExcelRequest {
  type: typeof ROOM_REPORT_EXCEL_REQUEST;
};

interface RoomReportExcelSuccess {
  type: typeof ROOM_REPORT_EXCEL_SUCCESS,
  contents: {};
}

interface RoomReportExcelFailure {
  type: typeof ROOM_REPORT_EXCEL_FAILURE;
}

export type RoomReportExcelActionTypes = RoomReportExcelRequest | RoomReportExcelSuccess | RoomReportExcelFailure;